(function ($) {
    const securityTab = $('.user-page.security-tab');

    if (securityTab) {
        const inputToggle = '.mfa-toggle input.toggle';
        const toggle = securityTab.find(inputToggle);

        toggle.on('click', (e) => {
            if (e.target.checked) {
                const enableMFA = new Event('enableMFA');
                document.querySelector(inputToggle).dispatchEvent(enableMFA);
            } else {
                const disableMFA = new Event('disableMFA');
                document.querySelector(inputToggle).dispatchEvent(disableMFA);
            }
        });
    }
})(jQuery);
